import { Event } from "event-system";

export class AnimationController {
    /**
     * On one of animation done
     */
    public readonly animationDone: Event;
    private readonly animations: Array<Promise<any>>;

    public constructor() {
        this.animationDone = new Event();
        this.animations = new Array();
    }

    public addAnimation(animation: Promise<any>): void {
        this.animations.push(animation);
        animation.then(this.onAnimationItemDone.bind(this));
    }

    public startAnimation(): Promise<void[]> {
        return Promise.all(this.animations);
    }

    protected onAnimationItemDone(): void {
        this.animationDone.emit();
    }
}

